<template>
  <div class="guests" v-if="inventoryBlock">{{guestCountEdit}}
    <div class="guests__item">
      <label class="label-control">Взрослые</label>
      <div class="input-group col-lg-3">
        <div class="input-group-btn" style="padding: 0">
          <button @click="subtractGuest(0)" class="btn btn-sm btn-round" type="submit"
                  style="padding: 6px 10px 5px 10px">
            <i class="glyphicon glyphicon-minus"></i>
          </button>
        </div>
        <input disabled type="text" style="text-align: center" size="3px"
               v-model="guestDict[0]" min="1"/>
        <div class="input-group-btn" style="padding: 0; position: relative">
          <button @click="addGuest(0)" class="btn btn-sm btn-round" type="submit"
                  style="padding: 6px 10px 5px 10px">
            <i class="glyphicon glyphicon-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-for="ageQualifier in hotelAgeQualifiers" :key="ageQualifier.id" class="guests__item">
      <label class="label-control">{{ ageQualifier.name }}</label>
      <div class="input-group">
        <div class="input-group-btn" style="padding: 0">
          <button @click="subtractGuest(ageQualifier.id)" class="btn btn-sm btn-round" type="submit"
                  style="padding: 6px 10px 5px 10px">
            <i class="glyphicon glyphicon-minus"></i>
          </button>
        </div>
        <input disabled type="text" style="text-align: center" size="3px" v-model="guestDict[ageQualifier.id]"/>
        <div class="input-group-btn" style="padding: 0">
          <button @click="addGuest(ageQualifier.id)" class="btn btn-sm btn-round pull" type="submit"
                  style="padding: 6px 10px 5px 10px;">
            <i class="glyphicon glyphicon-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GuestSelect',
  props: [
    'inventoryBlock',
    'guestCountEdit',
  ],
  data() {
    return {
      guestDict: {},
    };
  },
  computed: {
    guestCount() {
      const guests = [];
      Object.keys(this.guestDict).forEach((key) => {
        if (this.guestDict[key] > 0) {
          guests.push({
            age_qualifier: (key === '0') ? null : key,
            persons: this.guestDict[key],
          });
        }
      });
      return guests;
    },
    hotelAgeQualifiers() {
      const hotelId = Number(this.inventoryBlocks.find(a => a.id === Number(this.inventoryBlock)).hotel.id);
      return this.ageQualifiers.filter(ageQualifier => ageQualifier.hotel === hotelId);
    },
    ...mapGetters(
      {
        ageQualifiers: 'ageQualifiers',
        inventoryBlocks: 'inventoryBlocks',
      },
    ),
  },
  watch: {
    guestCount() {
      this.$emit('guestCountChanged', this.guestCount);
    },
    inventoryBlock() {
      this.generateGuestDict();
    },
  },
  mounted() {
    this.generateGuestDict();
  },
  methods: {
    generateGuestDict() {
      this.guestDict = { 0: 1 };
      this.hotelAgeQualifiers.forEach((ageQual) => {
        this.$set(this.guestDict, ageQual.id, 0);
        this.$emit('guestCountChanged', this.guestCount);
      });
      if (this.guestCountEdit) {
        this.guestCountEdit.forEach((item) => {
          this.$set(this.guestDict, item.age_qualifier ? item.age_qualifier : 0, item.persons);
        });
      }
    },
    addGuest(ageQualifierId) {
      const maxGuests = ageQualifierId > 0 ? 10 : 12;
      if (this.guestDict[ageQualifierId] < maxGuests) {
        this.guestDict[ageQualifierId] += 1;
      }
    },
    subtractGuest(ageQualifierId) {
      const minGuests = ageQualifierId > 0 ? 0 : 1;
      if (this.guestDict[ageQualifierId] > minGuests) {
        this.guestDict[ageQualifierId] -= 1;
      }
    },
  },
};
</script>
<style scoped>
  .form-group {
    margin-top: 12px;
  }
  .guests {
    display: flex;
    justify-content: space-evenly;
    width: 50%;
    float: left;
  }
  .guests__item {
    padding-right: 10px;
  }
  .guests__item:last-child {
    padding-right: 0;
  }
  @media screen and (max-width: 990px) {
    .guests {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }
</style>
